import { MappingText } from '@ni/nimble-components/dist/esm/mapping/text';
import { wrap } from '../../utilities/react-wrapper';

export { type MappingText };
export const NimbleMappingText = wrap(MappingText);
